import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_COLOR } from 'gcs-common/constants/IconConstants';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { getChannelInputIsSendingDisabled } from 'gcs-common/slices/messageInput/messageInputSelector';
import { useSelector } from 'react-redux';
import Button from '../../Button/Button';
import styles from './styles.module.scss';

interface SendButtonProps {
  onClick: () => void;
}

const SendButton = (props: SendButtonProps) => {
  const { onClick } = props;
  const selectedChannelId = useSelector(getSelectedChannelId);
  const disabled = useSelector(getChannelInputIsSendingDisabled(selectedChannelId));

  return (
    <Button disabled={disabled} type="button" onClick={onClick} className={styles.sendButton}>
      <IconComponent Icon={ICON.SEND} color={ICON_COLOR.WHITE} style={{ marginLeft: '2px' }} />
    </Button>
  );
};

export default SendButton;
